import { z } from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { FlexModificationPermanentModification } from '../../../loan/WorkoutPlan';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CompleteFlexModWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('completeFlexModWorkoutPlan'),
  workoutPlanId: WorkoutPlanId,
  data: FlexModificationPermanentModification,
});
export type CompleteFlexModWorkoutPlanEvent = z.infer<typeof CompleteFlexModWorkoutPlanEvent>;
